import axiosClient from "utils/api";

export const getAllSettings = async () => {
  const URL = "/admin/settings";
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get setting:", error);
    throw error;
  }
};

export const updateSettings = async (payload) => {
  const URL = "/admin/settings";
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: payload,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during update setting:", error);
    throw error;
  }
};
